
import "./internal.css";
import { useState, useEffect } from "react";

/* banco de dados */
import { db } from "../../services/firebaseConnection";
import { getAuth } from "firebase/auth";
import { collection, doc, setDoc, addDoc, getDocs, writeBatch } from "firebase/firestore";



export default function Operations() {
  
    useEffect(() => {
    // 1. Define a função global que o SDK chamará ao carregar
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: '936860817533052',
        cookie: true,
        xfbml: true,
        version: 'v22.0'
      });
      console.log("✅ SDK do Facebook inicializado com sucesso!");
    };

    // 2. Garante que o script seja injetado apenas uma vez
    const id = 'facebook-jssdk';
    if (document.getElementById(id)) return;

    const js = document.createElement('script');
    js.id = id;
    js.src = "https://facebook.net";
    js.async = true;
    js.defer = true;
    js.onerror = () => {
      console.error("❌ Erro ao carregar o script da Meta. Verifique se há bloqueadores de anúncios ativos.");
    };

    document.body.appendChild(js);
  }, []);


const handleConnectWhatsApp = () => {
  const appId = '936860817533052'; 
  const configId = '230098829822941'; 
  
  // Use exatamente a URL que está no topo do seu navegador
  const redirectUri = "http://gptmaker.ai"; 

  const oauthUrl = `https://facebook.com?` +
    `client_id=${appId}` +
    `&config_id=${configId}` +
    `&response_type=code` +
    `&override_default_response_type=true` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&scope=whatsapp_business_management,whatsapp_business_messaging`; // ADICIONE ISSO

  window.open(oauthUrl, 'facebook-login', 'width=600,height=700');
};






  

  return(
      <div>
          <span>Para criar um plano</span>
          <br /><br />
          <div><button type="button" onClick={criar_plano}>Criar Plano</button></div>
          <br /><br />
          <span>Para criar um telefone</span>
          <br /><br />
          <div><button type="button" onClick={criar_telephone}>Criar Telefone</button></div>
          <br /><br />
          <div><button type="button" onClick={apagarAgenda}>Apagar Agenda</button></div>
      </div>
  )
}










    
    async function criar_plano(data) {
        
        try {

            const plandoc = await setDoc(doc(db, "db_plan", "CMD2"), {
                ramo: "Médicos",
                atendimento: "W+E",
                valor: 7,
                data_criacao: new Date("2026-07-01T12:00:00Z"),
                data_inicio_vigencia: new Date("2026-07-01T12:00:00Z"),
                data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
            });

        } catch (erro) {
            console.log(erro);
            console.log("currentUser:", getAuth().currentUser);
        }
    }


    async function criar_telephone(data) {
        
        try {

            const plandoc = await setDoc(doc(db, "db_telephone", "551153046653"), {
                agente: "agente winners lembrete",
                data_criacao: new Date("2026-07-01T12:00:00Z"),
                id_gptmaker: "não associado",
                status: 2,
                telefone: "(11) 5304-6653",
                tipo: "chip virtual"
            });

        } catch (erro) {
            console.log(erro);
        }
    }


    async function apagarAgenda() {

        try {

            const idAgent = "5UpiTEp0XrAWidwJ0n8l";
            const dataInicial = "20260809";

            const diasRef = collection(db, "db_calendar", idAgent, "dias");
            const snapshot = await getDocs(diasRef);

            let batch = writeBatch(db);
            let contador = 0;

            for (const documento of snapshot.docs) {

                // como o id está no formato YYYYMMDD,
                // a comparação de string funciona perfeitamente
                if (documento.id >= dataInicial) {

                    batch.delete(doc(db, "db_calendar", idAgent, "dias", documento.id));
                    contador++;

                    // Firestore permite até 500 operações por batch
                    if (contador % 500 === 0) {
                        await batch.commit();
                        batch = writeBatch(db);
                    }
                }
            }

            if (contador % 500 !== 0) {
                await batch.commit();
            }

            console.log(`${contador} documentos removidos.`);

        } catch (erro) {
            console.error("Erro ao apagar agenda:", erro);
        }
    }


